// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestTags-cls1_5rR","cls2":"ResearchInterestTags-cls2_nZV ResearchInterestTags-cls1_5rR"};